import { ResponsivePie } from '@nivo/pie'
import React, { useState, useEffect } from 'react'
import axios from 'axios'



export default function MyResponsivePie({ shop, start, end /* see data tab */ }) {

    const [shops, setShops] = useState([])

    useEffect(() => {
        if (shop === "all") {
            axios
                .get(
                    `${process.env.REACT_APP_SERVER_URL}/api/dati/shops_no_interval?start=${start}&end=${end}`
                )
                .then((response) => {
                    let prepared_data = response.data.negozi.buckets.map(bucket => {
                        return {
                            "id": bucket.key === "" ? "00000" : bucket.key,
                            "value": bucket.per_negozio.buckets[0].valore.toFixed(2),
                            "quantita": bucket.per_negozio.buckets[0].quantita,
                            "prezzo_medio": ((bucket.per_negozio.buckets[0].prezzo_medio === undefined || bucket.per_negozio.buckets[0].prezzo_medio == null) ? "dati mancanti" : bucket.per_negozio.buckets[0].prezzo_medio)
                        }
                    });
                    setShops(prepared_data)
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
        } else {
            axios
                .get(
                    `${process.env.REACT_APP_SERVER_URL}/api/dati/shops_no_interval/${shop}?start=${start}&end=${end}`
                )
                .then((response) => {
                    console.log(response.data)
                    let prepared_data = response.data.negozi.buckets[0].per_negozio.buckets.map(bucket => {
                        return {
                            "id": shop === "all" ? "00000" : shop,
                            "value": bucket.valore.toFixed(2),
                            "quantita": bucket.quantita,
                            "prezzo_medio": ((bucket.prezzo_medio === undefined || bucket.prezzo_medio == null) ? "dati mancanti" : bucket.prezzo_medio)
                        }
                    });
                    setShops(prepared_data)
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
        }

    }, [start, end, shop]);


    if (shops) {

        return <ResponsivePie
            data={shops}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            colors={{ scheme: 'nivo' }}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
            radialLabelsSkipAngle={10}
            radialLabelsTextColor="#333333"
            radialLabelsLinkColor={{ from: 'color' }}
            sliceLabelsSkipAngle={10}
            sliceLabelsTextColor="#333333"
            defs={[
                {
                    id: 'dots',
                    type: 'patternDots',
                    background: 'inherit',
                    color: 'rgba(255, 255, 255, 0.3)',
                    size: 4,
                    padding: 1,
                    stagger: true
                },
                {
                    id: 'lines',
                    type: 'patternLines',
                    background: 'inherit',
                    color: 'rgba(255, 255, 255, 0.3)',
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10
                }
            ]}
        />
    }
}